import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper, TextField } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalPostService } from '../../../globalServices';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { checkPermission } from '../../../console_management/utils_v2';
import { jetStreamInstance, titanAviInstance } from '../../../shared/components';

const MrFundBalanceReport = ({ ownerList, lessee, assetList }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [selectedLessee, setLessee] = useState([]);
    const [selectedLessor, setLessor] = useState([]);
    const [assetTypes, setAssetTypes] = useState([]);

    const exportAssetLogReport = (extension) => {
        let assetsStr = assetTypes.map(item => ([item?.id, item?.asset_type]));
        let lessorStr = selectedLessor.map(item => item?.id)
        let lesseeStr = selectedLessee.map(item => item?.id)
        let validationInputs = {};

        validationInputs = {
            ...validationInputs,
            start_date: start_date ? moment(start_date).isAfter(moment(), "day") ? 'From Date Cannot be future date' : '' : 'Please enter From Date' ,
            end_date: end_date ? moment(end_date).isAfter(moment(), "day") ?titanAviInstance?'':'To Date Cannot be future date' : '' : 'Please enter To Date' ,
        }
        if (start_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                start_date: 'Please enter valid From Date'
            }
        }
        if (end_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                end_date: 'Please enter valid To Date'
            }
        }
        if (start_date !== 'Invalid date' && end_date !== 'Invalid date') {
            if (moment(end_date).isBefore(moment(start_date))) {
                validationInputs = {
                    ...validationInputs,
                    end_date: 'To Date Cannot be lesser than From Date'
                }
            }
        }
        let startDate = (start_date? moment(start_date).format(backendDateFormat) : null)
        let endDate = (end_date? moment(end_date).format(backendDateFormat) : null)

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            globalPostService(`/console/custom-reports/monthly_reserve_account_report/`, { 'file_type': extension, 'start_date': startDate, 'end_date': endDate, 'lessor_name_id': lessorStr, 'lessee_id': lesseeStr, 'asset_id': assetsStr })
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        setError({}); setEndDate(null); setStartDate(null); setLessor([]); setLessee([]); setAssetTypes([])
                    } else {
                        // enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    return (
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card'>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>MR Fund Balance Report</h4>
                                    <p>This report contains the MR fund balance grouped by lessor and lessee for each asset.</p>
                                </Grid>
                                <Grid item md={3}>
                                    {checkPermission('reports', 'custom_reports', 'EXP') ? <ExportMenu
                                        exportReportFn={(file) => exportAssetLogReport(file.extension)}
                                        files={[{ title: 'EXCEL', extension: 'xlsx' }]}
                                    /> : null}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="start_date"
                                            format={titanAviInstance ? "MM/YYYY" : fieldDateFormat}
                                            views={titanAviInstance ? ["year", "month"] : ["year", "month", "date"]}
                                            openTo={titanAviInstance ? "month" : "date"} 
                                            label="From Date"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            disableFuture
                                            value={start_date ? start_date : null}
                                            error={error.start_date ? true : false}
                                            helperText={error.start_date ? error.start_date : ''}
                                            onChange={(data) => { setStartDate(('start_date', titanAviInstance? moment(data)?.startOf('month').format(backendDateFormat): moment(data).format(backendDateFormat))); onResetErrorKey('start_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="end_date"
                                            label="To Date"
                                            format={titanAviInstance ? "MM/YYYY" : fieldDateFormat}
                                            views={titanAviInstance ? ["year", "month"] : ["year", "month", "date"]}
                                            openTo={titanAviInstance ? "month" : "date"} 
                                            disabled={!start_date ? true : false}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            minDate={moment(start_date)}
                                            disableFuture
                                            maxDate={moment(start_date).diff(moment(), 'month') === 0 ? moment(new Date()) : moment(start_date).add(300, 'M')}
                                            value={end_date ? end_date : null}
                                            error={error.end_date ? true : false}
                                            helperText={error.end_date ? error.end_date : ''}
                                            onChange={(data) => { setEndDate(('end_date', titanAviInstance? moment(data)?.endOf('month').format(backendDateFormat): moment(data).format(backendDateFormat))); onResetErrorKey('end_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={12}>
                                    <p className='lessor-select'><span onClick={() => { setLessor(ownerList); }}>Select All {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</span>{selectedLessor.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setLessor([]) }} >Remove All {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</span> : null}</p>
                                    <Autocomplete
                                        options={ownerList}
                                        getOptionLabel={option => option.name}
                                        id='lessor'
                                        value={selectedLessor}
                                        multiple
                                        onChange={(e, data) => setLessor(data)}
                                        renderInput={params => <TextField  {...params} label={jetStreamInstance ? "Lessor/Holdco" : "Lessor"} margin="normal" placeholder={`Select ${jetStreamInstance ? "Lessor/Holdco" : "Lessor"}`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <p className='lessor-select'><span onClick={() => setLessee(lessee)}>Select All Lessee</span> {selectedLessee?.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setLessee([]) }} >Remove All Lessee</span> : null} </p>
                                    <Autocomplete
                                        options={lessee}
                                        getOptionLabel={option => option.name}
                                        id='lessor'
                                        value={selectedLessee}
                                        multiple
                                        onChange={(e, data) => { setLessee(data) }}
                                        renderInput={params => <TextField  {...params} label={"Lessee"} margin="normal" placeholder={`Select Lessee`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <p className='lessor-select'><span onClick={() => { setAssetTypes(assetList); }}>Select All Assets</span>{assetTypes.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setAssetTypes([]) }} >Remove All Assets</span> : null}</p>
                                    <Autocomplete
                                        options={assetList}
                                        getOptionLabel={option => option.asset_name}
                                        id='assetTypes'
                                        value={assetTypes}
                                        labelKey="name"
                                        // valueKey="id"
                                        multiple
                                        onChange={(e, data) => { setAssetTypes(data); }}
                                        renderInput={params => <TextField {...params} label='Assets' margin="normal" placeholder={`Select Asset(s)`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}
export default withRouter(MrFundBalanceReport);